module.exports = __webpack_public_path__ + "img/create_apostille.6aab1d68.png";